// extracted by mini-css-extract-plugin
export default {"item":"bread_item__E0wa6","arrow":"bread_arrow__A37VB","icon":"bread_icon__8gjEV"};